<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家')" prop="merchantId">
                <a-select show-search :filter-option="merchantFilter" v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+$t('商家')" @change="merchantChange" allow-clear>
                  <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('门店')" prop="storeId">
                <a-select show-search :filter-option="storeFilter"  v-model="queryParam.storeId" :maxLength="32" :placeholder="$t('请选择')+$t('门店')" allow-clear>
                  <a-select-option v-for="item in storeList" :key="item.id">{{ item.storeName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品名称')" prop="goodsName">
                <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery"  :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商品分类" prop="merchantCategoryId">
                <a-tree-select v-model="queryParam.merchantCategoryId" style="width: 100%"
                               :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="categoryList" :placeholder="$t('请选择')+$t('商品分类')"
                               :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                               tree-default-expand-all allow-clear>
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品状态')" prop="status">
                <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                  <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" :disabled="multiple" @click="handleOn" v-hasPermi="['goods:goodsstore:batch']">
          <a-icon type="check" />{{$t('批量上架')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleOff" v-hasPermi="['goods:goodsstore:batch']">
          <a-icon type="stop" />{{$t('批量下架')}}
        </a-button>-->
        <a-button type="primary" @click="handleSync" :disabled="!queryParam.merchantId" v-hasPermi="['goods:goodsstore:add']">
          <a-icon type="sync" />{{$t('同步商品')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goodsstore:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <div slot="status" slot-scope="text, record"  >
          <div v-if="hasPermission('goods:goodsstore:batch')">
            <a-select style="width: 80%" v-model="record.status"  @change="onStatusChange(record)" v-if="record.status===1|| record.status===0">
              <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div v-else>
            <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status" />
          </div>
        </div>
        <span slot="stock" slot-scope="text, record">
            <a v-if="hasPermission('goods:goodsstore:edit')" @click="updateSkuStock(record.id,record.goodsType)">{{record.stock}}</a>
            <span v-else>{{record.stock}}</span>
          </span>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['goods:goodsstore:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['goods:goodsstore:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <update-sku-stock ref="updateSkuStock" @ok="getList"></update-sku-stock>
  </page-header-wrapper>
</template>

<script>
import {pageGoodsStore, listGoodsStore, delGoodsStore, syncGoodsStore,batchOff, batchOn} from '@/api/goods/goodsStore'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listSelectMerchant} from "@/api/merchant/merchantMerchant";
import {listSelectMerchantStore} from "@/api/merchant/merchantStore";
import store from "@/store";
import UpdateSkuStock from "./modules/UpdateSkuStock.vue";
import {merchantIdCategoryTree} from "@/api/goods/category";

export default {
  name: 'GoodsStore',
  components: {
    UpdateSkuStock,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      categoryList: [{id: "0", categoryName: ''}],
      merchantList:[],
      storeList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        merchantCategoryId: undefined,
        storeId: undefined,
        goodsName: undefined,
        status: undefined,
        stock: undefined,
        salesNum: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'goodsId',
          width: 190,
          align: 'center'
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 300,
        },
        /*{
          title: this.$t('单位'),
          dataIndex: 'unit',
        },*/
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: this.$t('商家'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('门店'),
          dataIndex: 'storeName',
          align: 'center'
        },

        /*{
          title: this.$t('商品状态'),
          scopedSlots: { customRender: 'status' },
          dataIndex: 'status',
          width: 100,
          align: 'center'
        },*/
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          scopedSlots: { customRender: 'stock' },
          align: 'center'
        },
        {
          title: this.$t('销量'),
          dataIndex: 'salesNum',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getMerchantList();
    if (this.userInfo.deptType===3) {
      this.getStoreList(null);
    }
  },
  computed: {
    ...mapGetters(['customDict',"userInfo"])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    hasPermission(val) {
      const allPermission = '*:*:*'
      const permissions = store.getters && store.getters.permissions
      const hasPermissions = permissions.some(permission => {
        return allPermission === permission || permissions.includes(permission)
      })
      return hasPermissions
    },

    /** 查询商品门店库存列表 */
    getList () {
      this.loading = true
     pageGoodsStore(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getMerchantCateList(merchantId) {
      /*这个方法是树的写法*/
      merchantIdCategoryTree({"merchantId":merchantId}).then(response => {
        this.categoryList=response.data
      })
    },

    merchantChange() {
      this.getStoreList(this.queryParam.merchantId)
      this.getMerchantCateList(this.queryParam.merchantId)
    },
    merchantFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
      })
    },
    getStoreList (merchantId) {
      listSelectMerchantStore({"merchantId":merchantId}).then(response => {
        this.storeList = response.data
        if (response.data.length === 1) {
          this.queryParam.storeId = response.data[0].id;
        }
      })
    },
    storeFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    onStatusChange(record) {
      //商品快捷上下架
      let data = {"idList": [record.id]};
      if (record.status===1) {
        batchOn(data).then(response => {
          if (response.code==='20001') {
            this.$message.success(this.$t('上架成功'), 3)
          }
          this.getList();
        })
      } else if (record.status===0) {
        batchOff(data).then(() => {
          this.getList()
          this.$message.success(
            this.$t('下架成功'),
            3
          )
        })
      }
    },

    /** 批量上架操作 */
    handleOn (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认上架'),
        onOk () {
          return batchOn(data)
            .then(response => {
              that.getList()
              if (response.code==='20001') {
                that.onSelectChange([], []);
                that.$message.success(
                  that.$t('上架成功'),
                  3
                )
              }
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },


    /** 批量下架操作 */
    handleOff(row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认下架'),
        onOk () {
          return batchOff(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('下架成功'),
                3
              )
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    updateSkuStock(goodsId,goodsType){
      this.$refs.updateSkuStock.show(goodsId,goodsType);
    },

    handleAdd() {
      if (!this.queryParam.merchantId) {
        this.$message.error("请先选择商家")
        return
      }
      this.$refs.createForm.handleAdd(this.queryParam.merchantId)

    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        storeId: undefined,
        goodsName: undefined,
        status: undefined,
        stock: undefined,
        salesNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delGoodsStore(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleSync() {
      if (!this.queryParam.merchantId) {
        this.$message.error("请先选择商家",3)
        return
      }
      let that = this
      let reqData = {"merchantId":this.queryParam.merchantId, "storeId":this.queryParam.storeId};
      this.$confirm({
        title: that.$t('确认同步商家的商品数据'),
        onOk () {
          return syncGoodsStore(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('同步成功',3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
          this.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/store/export',
            that.queryParam
          , `商品门店库存_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
